// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SignUp_form__2t9yj>input{margin:.5rem 0}.SignUp_statusMessage__2ZY4F{color:var(--color-error);font-weight:600;margin:2rem 0}.SignUp_buttonContainer__2VL9Z{position:relative;text-align:center;width:100%}", ""]);
// Exports
exports.locals = {
	"form": "SignUp_form__2t9yj",
	"statusMessage": "SignUp_statusMessage__2ZY4F",
	"buttonContainer": "SignUp_buttonContainer__2VL9Z"
};
module.exports = exports;
